import { JetView } from 'webix-jet';
import { devConfig, profile, concepts } from 'config/config';

/**
 * Represents the view for other incomes.
 */
export default class otherIncomesView extends JetView {
    /**
     * Configures the UI components and layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance
        const data = []; // Initial data array

        // Custom data driver for JSON
        webix.DataDriver.myjson = webix.extend(
            {
                toObject: function (arr) {
                    arr = webix.DataDriver.json.toObject(arr);
                    for (var i = 0; i < arr.length; i++) {
                        arr[i].id = arr[i].Name; // Set id to Name
                    }
                    return arr;
                },
            },
            webix.DataDriver.json,
        );

        // Data collection for concepts
        var newConceptList = new webix.DataCollection({
            data: concepts,
            datatype: 'myjson',
        });

        let totalIncomes = 0; // Variable to hold total incomes
        totalIncomes = data
            .map((item) => item.Value) // Extract values from data
            .reduce((prev, curr) => prev + curr, 0); // Calculate total

        // Configuration for the first income grid
        var gridIncomes1 = {
            rows: [
                {
                    view: 'datatable',
                    id: 'gridIncomes1',
                    css: 'webix_header_border webix_data_border auditreview_style',
                    autoheight: true,
                    columns: [
                        {
                            id: 'detailTittle',
                            header: '',
                            width: 50,
                            height: 25,
                            tooltip: _('Detalles'), // Tooltip for details
                            template: function (obj) {
                                return '';
                            },
                        },
                        {
                            id: 'Description',
                            header: {
                                text: 'Descripción',
                                css: { 'text-align': 'center' },
                            },
                            width: 200,
                        },
                        {
                            id: 'Reference',
                            header: {
                                text: 'Referencia',
                                css: { 'text-align': 'center' },
                            },
                            width: 120,
                        },
                        {
                            id: 'Concept',
                            header: {
                                text: 'Concepto',
                                css: { 'text-align': 'center' },
                            },
                            width: 120,
                        },
                        {
                            id: 'Value',
                            header: {
                                text: 'Valor',
                                css: { 'text-align': 'center' },
                            },
                            fillspace: true,
                        },
                    ],
                    data: data, // Data for the grid
                },
            ],
        };

        /**
         * Updates the sum of values in the second grid.
         * @returns {number} The calculated sum.
         */
        function updateSumm() {
            var summ = 0;
            $$('gridIncomes2').data.each(function (row) {
                summ += row.Value * 1 || 0; // Sum values, default to 0 if undefined
            });
            return summ;
        }

        const data2 = []; // Initial data for the second grid

        /**
         * Checks if a value is not empty.
         * @param {string} value - The value to check.
         * @returns {boolean} True if not empty, false otherwise.
         */
        function notEmpty(value) {
            return value != '';
        }

        /**
         * Checks if a value is a positive integer.
         * @param {number} value - The value to check.
         * @returns {boolean} True if positive, false otherwise.
         */
        function positiveInteger(value) {
            return value > 0;
        }

        // Configuration for the second income grid
        var gridIncomes2 = {
            rows: [
                {
                    view: 'datatable',
                    data: data2,
                    id: 'gridIncomes2',
                    select: 'row',
                    editable: true,
                    css: 'webix_header_border webix_data_border auditreview_style',
                    autoConfig: true,
                    columns: [
                        {
                            id: 'detailTittle',
                            header: '',
                            width: 50,
                            height: 25,
                            tooltip: _('Detalles'),
                            template: function (obj) {
                                return "<span class='webix_icon wxi-close torefuse'></span>"; // Close icon
                            },
                        },
                        { id: 'Description', editor: 'text', width: 200 },
                        { id: 'Reference', editor: 'text', width: 120 },
                        {
                            id: 'Concept',
                            width: 120,
                            sort: 'text',
                            editor: 'combo',
                            options: concepts, // Options for the combo editor
                            template: function (obj) {
                                return obj.Concept; // Display concept
                            },
                            suggest: {
                                template: '#Name#',
                                filter: function (item, Name) {
                                    if (item.Name.toString().toLowerCase().indexOf(Name.toLowerCase()) === 0)
                                        return true; // Filter suggestions
                                    return false;
                                },
                                body: {
                                    template: '#Name#',
                                    yCount: 7,
                                    on: {
                                        onItemClick: function (id) {},
                                    },
                                },
                            },
                        },
                        { id: 'Value', editor: 'text', fillspace: true },
                    ],
                    onClick: {
                        torefuse: function (euv, id) {
                            $$('gridIncomes2').remove(
                                $$('gridIncomes2').getSelectedId(), // Remove selected row
                            );
                        },
                    },
                    header: false,
                    rules: {
                        Description: notEmpty, // Validation rule
                        Concept: notEmpty, // Validation rule
                        Value: positiveInteger, // Validation rule
                    },
                    ready: function () {
                        this.validate(); // Validate on ready
                    },
                },
                {
                    view: 'text',
                    label: 'Total Egresos',
                    labelWidth: 100,
                    value: totalIncomes, // Display total incomes
                    readonly: true,
                    id: 'summIncomes',
                },
                {
                    cols: [
                        {
                            view: 'button',
                            label: 'Añadir Egreso',
                            click: function () {
                                var data = {};
                                $$('gridIncomes2').editStop(); // Stop editing
                                var id = $$('gridIncomes2').add(data, 1000000); // Add new row
                                $$('gridIncomes2').editRow(id); // Edit new row
                            },
                        },
                    ],
                },
            ],
        };

        // Event listener for updating the sum
        this.on(this.app, 'updateSumm', (sum) => {
            var total = totalIncomes + updateSumm(); // Calculate total
            $$('summIncomes').setValue(total); // Update total display
            vthis.app.callEvent('totalIncomes:sum', [{ total }]); // Trigger event
        });

        return {
            rows: [gridIncomes1, gridIncomes2], // Return layout
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        var vthis = this;
        $$('gridIncomes2').data.attachEvent('onStoreUpdated', function (id, obj, mode) {
            if (mode == 'add' || mode == 'update' || mode == 'delete') {
                if ($$('gridIncomes2').validate()) {
                    // Validate on store update
                    vthis.app.callEvent('updateSumm', [{}]); // Update sum event
                    vthis.app.callEvent('incomesObject', [{}]); // Trigger incomes object event
                }
            }
        });

        // Delay to ensure the update sum event is called
        webix.delay(
            function () {
                vthis.app.callEvent('updateSumm', [{}]);
            },
            '',
            '',
            100,
        );

        // AJAX request to fetch today's incomes
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetIncomesToday', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('gridIncomes1').define('data', resp.Data); // Set data for the first grid
                },
            });
    }
}

// FILE DOCUMENTED
